export default __webpack_public_path__ + "static/media/articalblue.ead05115.svg";